<!-- 页眉 -->
<template>
<div class="head__block">
  <div class="head-comp">
    <div class="content-size clearfix">
      <div class="head-nav right">
        <div class="cooperate right" @click="goCooperate()">合作代理</div>
        <ul class="right">
          <li class="left" v-for="(item, index) in navList" :key="index" @mouseenter="onMouseenter(index)"
              >
            <span
              :class="['nav-name', { ischose: isChose == index }]"

              @click="goPage(index)"
              >{{ item.title }}</span
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div  :class="isShow?'head-popover show-animate':'head-popover hide-animate'" @mouseleave="onMouseleave()">
    <div class="head-popover-content">
<div class="head-popover-left">
      <div class="head-popover-lt">1+2+X数字化智治教育生态圈</div>
      <div class="head-popover-lb">平台赋能应用 数据驱动业务</div>
    </div>
    <div class="head-popover-right icon-one" @click="scrollTo('dataWarehouse')">
      <div >
      <img  class="head-popover-right-url" src="@/../static/img/head/head-icon1.png" alt="">
      <!-- <img class="head-popover-right-url" src="@/../static/img/head/head-icon1-cursor.png" alt=""> -->
      </div>
      <div v-if="domId=='dataWarehouse' && routePath=='/product'">
      <img class="head-popover-right-sjx" src="@/../static/img/head/sjx.png" alt="">
      </div>
    </div>
    <div class="head-popover-right icon-two" @click="scrollTo('dataCenter')">
 <div >
      <img  class="head-popover-right-url" src="@/../static/img/head/head-icon2.png" alt="">
      <!-- <img class="head-popover-right-url" src="@/../static/img/head/head-icon2-cursor.png" alt=""> -->
      </div>
      <div v-if="domId=='dataCenter' && routePath=='/product'">
      <img class="head-popover-right-sjx" src="@/../static/img/head/sjx.png" alt="">
      </div>
      </div>
    <div class="head-popover-right icon-three" @click="scrollTo('dataApplication')">
 <div >
      <img  class="head-popover-right-url" src="@/../static/img/head/head-icon3.png" alt="">
      <!-- <img class="head-popover-right-url" src="@/../static/img/head/head-icon3-cursor.png" alt=""> -->
      </div>
      <div v-if="domId=='dataApplication' && routePath=='/product'">
      <img class="head-popover-right-sjx" src="@/../static/img/head/sjx.png" alt="">
      </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: "classStudent",
  props: ["isChose"],
  data() {
    return {
      domId: "dataWarehouse",
      routePath: "",
      isShow: false,
      navList: [
        { title: "首页", path: "/" },
        { title: "产品", path: "/product" },
        { title: "案例", path: "/case" },
        { title: "关于", path: "/about" },
      ],
    };
  },
  watch: {},
  created() {},
  mounted() {
    setTimeout(() => {
      this.routePath = this.$route.path;
    }, 1000);
  },
  methods: {
    goPage(index) {
      this.routePath = this.navList[index].path;
      if (this.$parent.naveChose != index) {
        this.$parent.naveChose = index;
        if (index == 0) {
          this.$router.push({ path: "/", query: {} });
        } else if (index == 1) {
          this.$router.push({ path: "/product", query: {} });
        } else if (index == 2) {
          this.$router.push({ path: "/case", query: {} });
        } else if (index == 3) {
          this.$router.push({ path: "/about", query: {} });
        }
      }
    },
    onMouseenter(index) {
      if (index == 1) {
        this.isShow = true;
      } else {
        this.isShow = false;
      }
    },
    scrollTo(domId) {
      this.domId = domId;
      if (this.routePath != "/product") {
        this.goPage(1);
        this.$nextTick(() => {
          setTimeout(() => {
            this.$parent.scrollTo(domId, true);
          }, 200);
          this.isShow = false;
        });
      } else {
        this.$parent.scrollTo(domId);
        this.isShow = false;
      }
    },
    onMouseleave(index) {
      this.isShow = false;
    },
    goCooperate() {
      if (this.$parent.naveChose != -1) {
        this.$parent.naveChose = -1;
        this.$router.push({ path: "/cooperate", query: {} });
      }
    },
  },
};
</script>
<style lang="less" scoped>
@keyframes show-gradient {
  0% {
    height: 0;
  }
  100% {
    height: 240px;
  }
}
@keyframes hide-gradient {
  0% {
    height: 240px;
  }
  100% {
    height: 0;
  }
}
@-webkit-keyframes show-gradient {
  0% {
    height: 0;
  }
  100% {
    height: 240px;
  }
}
@-webkit-keyframes hide-gradient {
  0% {
    height: 240px;
  }
  100% {
    height: 0;
  }
}
.show-animate {
  overflow: hidden;
  animation: show-gradient 0.2s linear;
  animation-fill-mode: forwards; //  动画停留在最后一刻，也就是隐藏
}
.hide-animate {
  overflow: hidden;
  animation: hide-gradient 0.2s linear;
  animation-fill-mode: forwards; //  动画停留在最后一刻，也就是隐藏
}

.content-size {
  width: 1392px;
  margin: 0 auto;
}
.head-comp {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: #fff;
  border-bottom: 1px solid #eee;
  z-index: 999;
}
.head-popover {
  z-index: 99;
  position: fixed;
  top: 72px;
  width: 100%;
  height: 240px;
  background: #ffffff;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  background-image: url("~@/assets/img/head/head-bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  &-content {
    margin: 0 auto;
    width: 1392px;
    height: 240px;
    display: flex;
  }
  &-left {
    margin-top: 79px;
  }
  &-lt {
    font-size: 32px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: bold;
    color: #1a66ff;
  }
  &-lb {
    height: 24px;
    font-size: 18px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #4e5969;
    margin-top: 16px;
  }
  &-right {
    margin-top: 60px;
    text-align: center;
    &-url {
      width: 120px;
      height: 120px;
      cursor: pointer;
      &:hover{
        opacity: .85;
      }
    }
    &-sjx {
      width: 16px;
      height: 10px;
      margin-top: 12px;
    }
  }
  .icon-one {
    margin-left: auto;
  }
  .icon-two {
    margin: 60px 48px 0;
  }
  .icon-three {
  }
}
.head-comp .content-size {
  background: url(~@/assets/img/logo.png) no-repeat 0 center;
  background-size: 272px 32px;
}
.head-nav {
  font-size: 14px;
  padding-right: 20px;
}
.head-nav ul {
  padding-right: 30px;
}
.head-nav li {
  height: 72px;
}
.nav-name {
  display: block;
  height: 72px;
  color: #666;
  box-sizing: border-box;
  border-bottom: 4px solid #fff;
  padding: 30px 2px 0;
  line-height: 1;
  cursor: pointer;
  margin: 0 28px;
  &:hover {
    color: #1a66ff;
  }
}
.nav-name.ischose {
  color: #1a66ff;
  border-bottom-color: #1a66ff;
}
.cooperate {
  background: #1a66ff;
  color: #fff;
  width: 96px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  border-radius: 20px;
  margin-top: 20px;
  cursor: pointer;
  font-size: 14px;
}
.head-popover-right {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue